import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributorsCashHistory = (id, page = 1, term = null, operation = null) => useQuery({ queryKey: ['distributors-cash-history', id, page, term, operation], queryFn: async () => {
    const callback = await API.get(`/distributors/${id}/cash?page=${page}${term ? `&term=${term}` : ''}${operation ? `&operation=${operation}` : ''}`)
    return callback?.data
}})

export default useDistributorsCashHistory